var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5739 30.636V16.9004H9V11.9549H12.5739V7.73083C12.5739 4.41151 14.685 1.36328 19.5494 1.36328C21.5189 1.36328 22.9753 1.55516 22.9753 1.55516L22.8606 6.1734C22.8606 6.1734 21.3753 6.15871 19.7545 6.15871C18.0003 6.15871 17.7193 6.98025 17.7193 8.3438V11.9549H23L22.7702 16.9004H17.7193V30.636H12.5739Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e27ec98808da734e2a3551ad4e28d6e4.svg";
export { ForwardRef as ReactComponent };